import { render, staticRenderFns } from "./android.vue?vue&type=template&id=3bb410c0&scoped=true"
import script from "./android.vue?vue&type=script&lang=js"
export * from "./android.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb410c0",
  null
  
)

export default component.exports